import { useMemo } from 'react';
import { Group, Player } from '../types';

export const useGroupUnseenStatus = (group: Group | undefined, userProfile?: Player | null) => {
    return useMemo(() => {
        if (!group) return false;

        const firestoreVisit = userProfile?.lastVisitedGroups?.[group.id];
        const lastVisitStr = localStorage.getItem(`padel_last_visit_group_${group.id}`);
        // If no last visit, we consider it has unseen items only if there's actually a tournament or matchmaking
        const localVisit = lastVisitStr ? parseInt(lastVisitStr, 10) : 0;
        const lastVisit = Math.max(firestoreVisit || 0, localVisit);

        let hasUnseen = false;

        // Check tournaments
        if (group.tournaments) {
            for (const t of group.tournaments) {
                if (t.createdAt) {
                    const createdDate = new Date(t.createdAt).getTime();
                    if (createdDate > lastVisit) {
                        hasUnseen = true;
                        break;
                    }
                }
            }
        }

        // Check matchmakings
        if (!hasUnseen && group.matchmakingRequests) {
            for (const m of group.matchmakingRequests) {
                if (m.createdAt) {
                    const createdDate = new Date(m.createdAt).getTime();
                    if (createdDate > lastVisit) {
                        hasUnseen = true;
                        break;
                    }
                }
            }
        }

        return hasUnseen;
    }, [group]);
};
